<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Timesheet Adjustment Approvals</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields" [chequeNumbers]="chequeNumbers"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Approve</strong> and <strong>Reject</strong> actions, please select the
                                applicable timesheet.</li>
                            <li>The <strong>Approve All</strong> and <strong>Reject All</strong> actions will update all
                                timesheets that match the search criteria OR all the selected timesheets.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched && !listReloading) {
                    <ppl-list-table [actionButtons]="actionButtons" (actionInvoked)="gridAction($event)" [cols]="cols"
                        [customDataLoaded]="true" [data]="timesheets" [disableSearch]="true" [disableSort]="true"
                        [enableActions]="false" [enablePageActions]="!isReadOnly" [from]="'timesheet'" [gridTitle]="false"
                        [lineItemCols]="lineItemCols" [listButton]="isReadOnly ? [] : buttons" [loadPage]="true" [pagination]="true"
                        [showCustomSearch]="false" [showExpandIcon]="true"
                        [showLineItem]="true" [showLineItemActions]="false" [timesheetFor]="'pendedTimesheet'"
                        (onPageLoad)="onPageLoad($event)" (rowCellClicked)="onCellClicked($event)"
                        (rowDetailEvent)="rowExpanded($event)"
                        [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else if(!listReloading) {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
    }
</ng-container>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [showButtons]="false" [showOkButton]="false"
    [showClose]="true" [size]="'medium'" [position]="'center'">
    <div class="p-10">
        <form nz-form nz-row [formGroup]="approvalTimesheetForm" class="ppl-p0 mt-2">
            <table class="approval-dialog-table">
                <thead>
                    <tr>
                        <th style="background-color: #a8e4e14d;">{{this.commentText}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input formControlName="comments" nz-input id="comments"
                                placeholder="Enter comments"
                                [nzStatus]="approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched ? 'error' : ''" />
                            @if(approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched) {
                                <div class="error-message">Please add the reject comments.</div>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="this.isDialogNoteDisplayed" class="alert alert-warning">
                <strong>{{this.dialogNoteMessage}}</strong>
            </div>
            <div class="custom-row w-100 save-row">
                <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px;'" label={{dialogButtonLabel}}
                    icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            </div>
        </form>
    </div>
</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'timesheet'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

